import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "logo" }
const _hoisted_2 = ["src"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.type === 'logo')
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: $options.logo
        }, null, 8 /* PROPS */, _hoisted_2))
      : (_openBlock(), _createBlock(_component_Icon, {
          key: 1,
          size: $props.size,
          icon: $options.icon,
          stroke: $options.stroke
        }, null, 8 /* PROPS */, ["size", "icon", "stroke"]))
  ]))
}